import { render, staticRenderFns } from "./CriteriosElegibilidade.vue?vue&type=template&id=649d544f"
import script from "./CriteriosElegibilidade.vue?vue&type=script&lang=js"
export * from "./CriteriosElegibilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports